import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Sparkles, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/lib/api';

const AIFormFill = ({ formData, onFillComplete, context = '' }) => {
  const [loading, setLoading] = useState(false);

  const handleAIFill = async () => {
    setLoading(true);
    try {
      const response = await api.post('/ai/form-assist', {
        form_data: formData,
        context: context,
      });
      
      if (response.data.filled_data) {
        onFillComplete(response.data.filled_data);
        toast.success('AI filled the form!', {
          description: 'Review and adjust as needed',
        });
      }
    } catch (error) {
      toast.error('AI assist failed', {
        description: 'Please fill the form manually',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      type="button"
      onClick={handleAIFill}
      disabled={loading}
      className="bg-gradient-to-r from-[#C9A961] to-[#D4C278] text-black hover:from-[#D4C278] hover:to-[#C9A961] transition-all duration-300 shadow-gold group"
    >
      {loading ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          AI Filling...
        </>
      ) : (
        <>
          <Sparkles className="mr-2 h-4 w-4 group-hover:rotate-12 transition-transform" />
          AI Fill Form
        </>
      )}
    </Button>
  );
};

export default AIFormFill;
